export const getErrorMessage = (error: any) => {
  return (
    error?.response?.data?.message ||
    error?.message ||
    'Lỗi không xác định, vui lòng liên hệ với quản trị viên'
  );
};
